import React from 'react';

function Enterprise() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-gray-100 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          Enterprise Solutions
        </h1>

        <div className="mt-8 text-gray-400 leading-relaxed max-w-3xl">
          <p className="mb-6">
          Enhance your admissions and candidate evaluation process with our enterprise-grade AI-powered interview platform, designed to support business schools in assessing applicants efficiently and objectively. Whether for admissions, scholarship evaluations, or mock interview training, our solution ensures a seamless and data-driven experience and our solutions adapt to your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          <div className="bg-gray-900/30 backdrop-blur-sm rounded-2xl p-8 border border-gray-800/50">
            <h2 className="text-2xl font-semibold text-white mb-6">Enterprise Features</h2>
            <ul className="space-y-4 text-gray-400">
              <li className="flex items-start">
                <span className="text-emerald-400 mr-2">•</span>
                Custom interview scenarios and questions
              </li>
              <li className="flex items-start">
                <span className="text-emerald-400 mr-2">•</span>
                Dedicated account management
              </li>
              <li className="flex items-start">
                <span className="text-emerald-400 mr-2">•</span>
                Advanced analytics and reporting
              </li>
              <li className="flex items-start">
                <span className="text-emerald-400 mr-2">•</span>
                Scalable for large applicant pools
              </li>
              <li className="flex items-start">
                <span className="text-emerald-400 mr-2">•</span>
                Faculty involvement & review
              </li>
              <li className="flex items-start">
                <span className="text-emerald-400 mr-2">•</span>
                AI-assisted shortlisting
              </li>
              <li className="flex items-start">
                <span className="text-emerald-400 mr-2">•</span>
                Single Sign-On (SSO) integration
              </li>
              <li className="flex items-start">
                <span className="text-emerald-400 mr-2">•</span>
                Custom branding options
              </li>
            </ul>
          </div>

          <div className="bg-gray-900/30 backdrop-blur-sm rounded-2xl p-8 border border-gray-800/50">
            <h2 className="text-2xl font-semibold text-white mb-6">Contact For Enterprise Solutions</h2>
            <p className="text-gray-400 mb-6">
              Get in touch with our team to learn more about our enterprise solutions and pricing.
            </p>
            <a 
              href="mailto:iimcatinterview@gmail.com"
              className="inline-block px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:opacity-90 transition-opacity"
            >
              Contact Our Team
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Enterprise; 